import { Component, input, output } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

export interface VideoCardConfig {
  key: string;
  displayName: string;
  placeholder: string;
}

@Component({
  selector: "app-video-card",
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: "./video-card.component.html",
  styleUrls: ["./video-card.component.scss"],
})
export class VideoCardComponent {
  // Inputs usando la nueva sintaxis de signals
  config = input.required<VideoCardConfig>();
  videoUrl = input<string>("");
  loading = input<boolean>(false);

  // Outputs usando la nueva sintaxis
  updateVideo = output<string>();
  visualizeVideo = output<string>();
  videoUrlChange = output<string>();

  onUpdate(): void {
    this.updateVideo.emit(this.config().key);
  }

  onVisualize(): void {
    this.visualizeVideo.emit(this.config().key);
  }

  onVideoUrlChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.videoUrlChange.emit(target.value);
  }
}
